// eslint-disable-next-line import/no-unresolved
require('nprogress');
// eslint-disable-next-line import/no-unresolved
require('noty');
require('bootstrap');
// eslint-disable-next-line import/no-unresolved
require('jquery-form-validator');
/* eslint-env browser */
/* eslint-disable no-alert, no-console, prefer-destructuring */
/* global js_lang, uk_msg */

((window, google) => {
  let map = null;
  let selectedMarker = null;
  let currHighestZIndex = 0;
  let page = 1;
  let hasNextPage = true;
  let isLoading = false;

  let mapCenterLatLng = null;
  const merchantBounds = new google.maps.LatLngBounds();

  const bounds = new google.maps.LatLngBounds();
  const reviewModal = document.getElementById('review-modal');

  const lat = document.getElementById('client_lat') ? document.getElementById('client_lat').value : null;
  const long = document.getElementById('client_long') ? document.getElementById('client_long').value : null;

  const collectFormData = (form) => {
    const data = [];
    const { elements } = form;
    for (let i = 0, elementsCount = elements.length; i < elementsCount; i += 1) {
      const el = elements[i];
      data[i] = `${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`;
    }
    return data.join('&');
  };

  const setMarkers = (merchants) => {
    if (merchants.length) {
      for (let i = 0, merchantsCount = merchants.length; i < merchantsCount; i += 1) {
        const marker = new google.maps.Marker({
          position: {
            lat: parseFloat(merchants[i].latitude),
            lng: parseFloat(merchants[i].lontitude),
          },
          label: { text: merchants[i].labelText || `${i + 1}`, color: 'white' },
          icon: document.getElementById('google-map-marker-img').value,
          map,
          zIndex: currHighestZIndex += 1,
        });

        marker.addListener('click', () => { // eslint-disable-line no-loop-func
          if (selectedMarker) {
            selectedMarker.setIcon(document.getElementById('google-map-marker-img').value);

            document
              .querySelector('.count-number.selected-card-number').classList
              .remove('selected-card-number');

            document
              .querySelector('.selected-search-result-card').classList
              .remove('selected-search-result-card');
          }

          marker.setIcon(document.getElementById('google-map-selected-marker-img').value);
          marker.setZIndex(currHighestZIndex += 1);
          selectedMarker = marker;

          document
            .getElementById(`card-merchant-${merchants[i].merchant_id}`)
            .scrollIntoView({ behavior: 'smooth', block: 'center' });

          document
            .querySelector(`#card-merchant-${merchants[i].merchant_id} .count-number`).classList
            .add('selected-card-number');

          document
            .getElementById(`card-merchant-${merchants[i].merchant_id}`).classList
            .add('selected-search-result-card');
        });

        bounds.extend(marker.getPosition());
      }
    }

    if (selectedMarker) {
      selectedMarker.setZIndex(currHighestZIndex += 1);
    }

    map.setCenter(bounds.getCenter());

    google.maps.event.addListenerOnce(map, 'bounds_changed', function setZoomToMap() {
      map.fitBounds(bounds);

      // set a minimum zoom
      // if you got only 1 marker or all markers are on the same address
      // map will be zoomed too much.
      if (this.getZoom() > 15) {
        this.setZoom(15);
      }
    });
  };

  const initMap = () => {
    map = new google.maps.Map(document.getElementById('search-map-results'), {
      zoomControl: true,
      zoom: 10,
      disableDefaultUI: true,
    });

    // eslint-disable-next-line no-shadow
    const lat = parseFloat(document.getElementById('client_lat').value);
    const lng = parseFloat(document.getElementById('client_long').value);
    const latLng = new google.maps.LatLng(lat, lng);
    map.setCenter(latLng);

    // eslint-disable-next-line no-use-before-define
    const merchants = getMerchants();
    setMarkers(merchants);
  };

  const getMerchantsElements = () => document.getElementsByClassName('merchant-search-result');

  const getMerchants = () => {
    const elements = getMerchantsElements();
    const merchants = [];

    for (let i = 0, n = elements.length; i < n; i += 1) {
      const dataset = elements[i].dataset;
      merchants.push({
        merchant_id: dataset.merchant_id,
        restaurant_slug: dataset.restaurant_slug,
        restaurant_name: dataset.restaurant_name,
        street: dataset.street,
        city: dataset.city,
        state: dataset.state,
        latitude: dataset.latitude,
        lontitude: dataset.lontitude,
        merchant_address: dataset.merchant_address,
        distance: dataset.distance,
      });
    }

    return merchants;
  };

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const getUrlParameter = (url, parameter) => {
    const regex = new RegExp(`[\\?|&]${parameter.toLowerCase()}=([^&#]*)`);
    const results = regex.exec(`?${url.toLowerCase().split('?')[1]}`);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  const loadDrivingDistance = () => {
    $('.deliveryDistance').each(function drivingDistance() {
      const element = $(this);
      const clientLat = element.attr('clientLat');
      const clientLon = element.attr('clientLon');
      const merchantLat = element.attr('merchantLat');
      const merchantLon = element.attr('merchantLon');
      const distanceType = element.attr('distanceType');

      const params = `action=getDrivingDistance&currentController=store&clientLat=${clientLat}&clientLon=${clientLon}&merchantLat=${merchantLat}&merchantLon=${merchantLon}&distanceType=${distanceType}`;

      if (element.find('img').length > 0) {
        $.ajax({
          type: 'POST',
          url: '/admin/ajax',
          data: params,
          dataType: 'json',
          success(data) {
            element.html(data.details);
          },
          error() {
            element.html('');
          },
        });
      }
    });
  };

  const initMerchants = () => {
    const merchants = getMerchantsElements();
    if (merchants.length < 2) {
      return;
    }

    // Take one before last from the end
    const lastOnPage = merchants[merchants.length - 2];
    if (isElementInViewport(lastOnPage)) {
      // eslint-disable-next-line  no-use-before-define
      loadMore();
    }

    // For bigger screens
    if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) >= 991) {
      const listContainer = document.getElementById('search-results-section');
      listContainer.addEventListener('scroll', (event) => {
        const element = event.currentTarget;
        // eslint-disable-next-line max-len
        if (hasNextPage && !isLoading && (element.scrollHeight - element.scrollTop <= element.offsetHeight + 200)) {
          // eslint-disable-next-line no-use-before-define
          loadMore();
        }
      });
    } else {
      // For smaller screens
      window.addEventListener('scroll', () => {
        // eslint-disable-next-line no-shadow
        const merchants = getMerchantsElements();
        // Take one before last from the end
        // eslint-disable-next-line no-shadow
        const lastOnPage = merchants[merchants.length - 2];
        if (hasNextPage && !isLoading && isElementInViewport(lastOnPage)) {
          // eslint-disable-next-line no-use-before-define
          loadMore();
        }
      });
    }
  };

  const loadMore = () => {
    page += 1;
    isLoading = true;
    $.ajax({
      type: 'GET',
      url: `/store/merchants${window.location.search}&page=${page}&lat=${lat}&long=${long}`,
      dataType: 'html',
      success(data) {
        hasNextPage = !!data;
        const listContainer = document.getElementById('search-results-container');
        listContainer.insertAdjacentHTML('beforeend', data);
        loadDrivingDistance();
        // eslint-disable-next-line no-use-before-define
        loadMerchantOpenInfo();
        const merchants = getMerchants();
        setMarkers(merchants);
        isLoading = false;
      },
      error(error) {
        console.log('Error: ', error);
        isLoading = false;
      },
    });
  };

  const loadMerchantOpenInfo = () => {
    $('.search-results-list .open-info').each(function MerchantOpenInfo() {
      const element = $(this);
      const merchantId = element.attr('merchant_id');

      const params = `action=getMerchantOpenInfo&merchant_id=${merchantId}`;

      if (element.find('img').length > 0) {
        $.ajax({
          type: 'POST',
          url: '/admin/ajax',
          data: params,
          dataType: 'json',
          success(data) {
            element.html(data.details);
          },
          error() {
            element.html('');
          },
        });
      }
    });
  };

  const initMerchantMap = () => {
    // Showing the map for merchant
    const merchantMap = new google.maps.Map(document.getElementById('merchant-map-container'), {
      zoom: 15,
      disableDefaultUI: true,
    });

    const merchantLat = parseFloat($('#merchant_map_latitude').val());
    const merchantLng = parseFloat($('#merchant_map_longtitude').val());

    if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) >= 991) {
      // Shift to right
      mapCenterLatLng = new google.maps.LatLng(merchantLat, merchantLng - 0.01);
    } else {
      // Shift to top
      mapCenterLatLng = new google.maps.LatLng(merchantLat - 0.007, merchantLng);
    }

    const merchantMarker = new google.maps.Marker({
      position: {
        lat: parseFloat(merchantLat),
        lng: parseFloat(merchantLng),
      },
      icon: document.getElementById('google-map-marker-img').value,
      map: merchantMap,
      animation: google.maps.Animation.DROP,
    });

    merchantBounds.extend(merchantMarker.getPosition());
    merchantMap.setCenter(mapCenterLatLng);
  };

  if (document.getElementById('search-map-results')) {
    window.addEventListener('load', () => {
      initMap();
      initMerchants();
    });
  }

  if (document.getElementById('merchant-map-container')) {
    window.addEventListener('load', () => {
      initMerchantMap();
    });
  }

  class ReviewForm {
    constructor(form) {
      this.opt_form = form;
      if (!this.opt_form) {
        throw new Error('Cannot find review form');
      }
      this.action = 'addReviews';

      this.starts = document.querySelectorAll('#review-modal .rate-star img');
      this.initHandlers();
    }

    initHandlers() {
      this.starts.forEach(item => item.addEventListener('click', ReviewForm.ratingStartClick.bind(item)));
      this.starts.forEach(item => item.addEventListener('mouseenter', this.ratingStartMouseEnter.bind(item)));
      this.starts.forEach(item => item.addEventListener('mouseleave', ReviewForm.ratingStartMouseLeave.bind(item)));
    }

    submit(event) {
      event.stopPropagation();
      event.preventDefault();

      const initialReviewRating = parseInt(document.getElementById('initial_review_rating').value, 10);
      if (initialReviewRating > 0) {
        const data = `${collectFormData(this.opt_form)}&action=${this.action}`;

        $.ajax({
          type: 'POST',
          url: '/admin/ajax',
          dataType: 'json',
          data,
          success: ReviewForm.onSuccess.bind(this),
          error: ReviewForm.onError.bind(this),
        });
      } else {
        alert('Please select your rating');
      }
    }

    static ratingStartClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const selectedRating = this.getAttribute('value');
      const starts = document.querySelectorAll('#review-modal .rate-star img');
      starts.forEach((start) => {
        const rating = start.getAttribute('value');
        if (rating <= selectedRating) {
          start.setAttribute('src', '/assets/build/img/star.svg');
        } else {
          start.setAttribute('src', '/assets/build/img/star-inactive.svg');
        }
      });

      document.getElementById('initial_review_rating').value = selectedRating;
    }

    ratingStartMouseEnter(event) {
      event.preventDefault();
      event.stopPropagation();
      const selectedRating = this.getAttribute('value');
      const initialReviewRating = document.getElementById('initial_review_rating').value;
      const starts = document.querySelectorAll('#review-modal .rate-star img');
      starts.forEach((start) => {
        const rating = start.getAttribute('value');
        if (rating <= selectedRating && initialReviewRating <= selectedRating) {
          start.setAttribute('src', '/assets/build/img/star.svg');
        }
      });
    }

    static ratingStartMouseLeave(event) {
      event.preventDefault();
      event.stopPropagation();

      const initialReviewRating = document.getElementById('initial_review_rating').value;
      const starts = document.querySelectorAll('#review-modal .rate-star img');
      starts.forEach((start) => {
        const rating = start.getAttribute('value');
        if (rating <= initialReviewRating) {
          start.setAttribute('src', '/assets/build/img/star.svg');
        } else {
          start.setAttribute('src', '/assets/build/img/star-inactive.svg');
        }
      });
    }

    static onSuccess(data) {
      if (data.code === 1) {
        $(reviewModal).modal('hide');
        const addedReview = data.details.html;

        $('#leave-review-div').after(addedReview);

        // Reset popup data
        $('#reviewTextArea').val('');
        $('#initial_review_rating').val('');
        const modalStarts = document.querySelectorAll('#review-modal .rate-star img');
        modalStarts.forEach((start) => {
          start.setAttribute('src', '/assets/build/img/star-inactive.svg');
        });

        // Reset summary data
        const ratings = data.details.rating.ratings;
        const votes = data.details.rating.votes;
        $('a.rate-review').html(`(${votes})`);
        $('span.rate-review').html(`(${votes})`);

        const leaveReviewStarts = document.querySelectorAll('#leave-review-div .rate-star img');
        leaveReviewStarts.forEach((start) => {
          start.setAttribute('src', '/assets/build/img/star-inactive.svg');
          const rating = start.getAttribute('value');
          if (rating <= ratings) {
            start.setAttribute('src', '/assets/build/img/star.svg');
          }
        });

        const supplierStarts = document.querySelectorAll('.supplier-description .rate-star img');
        supplierStarts.forEach((start) => {
          start.setAttribute('src', '/assets/build/img/star-inactive.svg');
          const rating = start.getAttribute('value');
          if (rating <= ratings) {
            start.setAttribute('src', '/assets/build/img/star.svg');
          }
        });
      } else {
        alert(data.msg);
      }
    }

    static onError() {
      alert('Something went wrong. Please try again');
    }
  }

  $(document).ready(() => {
    const reviewFormEl = document.querySelector('#review-modal .modal-content form');
    if (reviewFormEl) {
      const reviewForm = new ReviewForm(reviewFormEl);

      $(reviewFormEl).validate({
        errorClass: 'validation-error',
        rules: {
          initial_review_rating: {
            required: true,
          },
          review_content: {
            required: true,
          },
        },
        messages: {
          initial_review_rating: {
            required: 'Please select your rating',
          },
          review_content: {
            required: 'Please enter your review',
          },
        },
        submitHandler(form, event) {
          reviewForm.submit(event);
        },
      });
    }

    $(document).on('change', '#sort-dropdown-merchants', function searchChange() {
      const sortFilter = $(this).val();
      const url = window.location.href;
      const cuisine = getUrlParameter(url, 'cuisine');
      const q = getUrlParameter(url, 'q');
      const address = getUrlParameter(url, 'address');
      const filterDeliveryType = getUrlParameter(url, 'delivery_type');
      const filterProviderType = getUrlParameter(url, 'provider_type');
      const filterMinOrder = getUrlParameter(url, 'min_order');
      const filterMinDelivery = getUrlParameter(url, 'min_delivery');

      let deliveryPart = '';
      let providerPart = '';
      let minOrder = '';
      let minDelivery = '';

      hasNextPage = true;
      isLoading = false;
      page = 1;

      if (filterDeliveryType !== '') deliveryPart = `&delivery_type=${filterDeliveryType}`;
      if (filterProviderType !== '') providerPart = `&provider_type=${filterProviderType}`;
      if (filterMinOrder !== '') minOrder = `&min_order=${filterMinOrder}`;
      if (filterMinDelivery !== '') minDelivery = `&min_delivery=${filterMinDelivery}`;

      const pageUrl = `/store/search?cuisine=${cuisine}&q=${q}&address=${address}${deliveryPart}${providerPart}${minOrder}${minDelivery}&sort_filter=${sortFilter}`;

      window.history.pushState({ path: pageUrl }, '', pageUrl);

      $.ajax({
        type: 'GET',
        url: `/store/merchants${window.location.search}&page=${page}&lat=${lat}&long=${long}`,
        dataType: 'html',
        success(data) {
          hasNextPage = !!data;
          $('div#search-results-container').html(data);

          selectedMarker = null;
          initMap();

          const merchants = getMerchants();
          setMarkers(merchants);
          initMerchants();

          loadDrivingDistance();
          loadMerchantOpenInfo();

          isLoading = false;
        },
        error(error) {
          console.log('Error: ', error);
          isLoading = false;
        },
      });
    });

    $(document).on('change', '#sort-providers-dropdown', function browseMerchantsOrder() {
      $('.loading').show();
      const sortFilter = $(this).val();
      const merchantListId = '#merchants-list';
      let curRoute = $('.container').find('[name="route"]').val();
      curRoute = curRoute.replace(/[&?]((sort_filter)|(page))[^&]+/g, ''); // eslint-disable-line no-param-reassign

      const newUrl = `${window.location.origin}${curRoute}?sort_filter=${sortFilter}`;

      window.history.pushState({ path: newUrl }, '', newUrl);

      $(merchantListId).load(
        `${newUrl} ${merchantListId} > *`,
        () => {
          $('.loading').hide();
        },
      );
    });

    loadDrivingDistance();
    loadMerchantOpenInfo();
  });

  // function busy(e) {
  //   if (e) {
  //     $('body').css('cursor', 'wait');
  //   } else $('body').css('cursor', 'auto');
  //
  //   if (e) {
  //     NProgress.set(0.0);
  //     NProgress.inc();
  //   } else {
  //     NProgress.done();
  //   }
  // }

  // function removeNotices() {
  //   $('.uk-alert').remove();
  // }

  // function setMessage(msg) {
  //   new Noty({
  //     text: msg,
  //     type: 'warning',
  //     theme: 'relax',
  //     layout: 'topCenter',
  //     timeout: 2500,
  //     animation: {
  //       open: 'animated fadeInDown', // Animate.css class names
  //       close: 'animated fadeOut', // Animate.css class names
  //     },
  //   }).show();
  // }

  // function setMessageSuccess(msg) {
  //   new Noty({
  //     text: msg,
  //     type: 'success',
  //     theme: 'relax',
  //     layout: 'topCenter',
  //     timeout: 2500,
  //     animation: {
  //       open: 'animated fadeInDown', // Animate.css class names
  //       close: 'animated fadeOut', // Animate.css class names
  //     },
  //   }).show();
  // }

  /* eslint-disable indent */
  // function submitForm(formid) {
  //   let formId;
  //   removeNotices();
  //
  //   if (formid) {
  //     formId = formid;
  //   } else {
  //     formId = $('form').attr('id');
  //   }
  //
  //   const btn = $(`#${formId} input[type="submit"]`); // eslint-disable-line no-undef
  //   const btnCap = btn.val();
  //   btn.attr('disabled', true);
  //   btn.val(js_lang.processing);
  //
  //   busy(true);
  //
  //   const params = $(`#${formId}`).serialize(); // eslint-disable-line no-undef
  //   const action = $(`#${formId}`).find('#action').val(); // eslint-disable-line no-undef
  //
  //   $.ajax({
  //     type: 'POST',
  //     url: ajax_url,
  //     data: params,
  //     dataType: 'json',
  //     success(data) {
  //       busy(false);
  //       btn.attr('disabled', false);
  //       btn.val(btnCap);
  //       if (data.code === 1) {
  //         setMessageSuccess(data.msg);
  //
  //         if (action === 'subscribeNewsletter') {
  //           $('#subscriber_email').val('');
  //           $('.subscription').hide();
  //           $('.featured-merchants-hr').addClass('border-0');
  //         } else if (action === 'setSearchQueries') {
  //           $('#no-results_product-name').val('');
  //           $('#no-results_email').val('');
  //         }
  //       } else {
  //         setMessage(data.msg);
  //       }
  //     },
  //     error() {
  //       btn.attr('disabled', false);
  //       btn.val(btnCap);
  //       busy(false);
  //       setMessage('ERROR');
  //     },
  //   });
  // }

  /* eslint-disable indent */
//   // init email subscribe form
//   $.validate({
//     form: '#frm-subscribe',
//     language: jsLanguageValidator,
//     onError() {
//     },
//     onSuccess() {
//       submitForm('frm-subscribe');
//       return true;
//     },
//   });
//
//   $.validate({
//     form: '#form-noresults',
//     language: jsLanguageValidator,
//     onError() {
//     },
//     onSuccess() {
//       submitForm('form-noresults');
//       return true;
//     },
//   });

  function successGeo(position, ignoreCurrValue = false) {
    if (!ignoreCurrValue && $('#s').val() !== '') {
      return;
    }

    const positionLat = position.coords.latitude;
    const positionLng = position.coords.longitude;
    const latlng = new google.maps.LatLng(positionLat, positionLng);
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ latLng: latlng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          if (typeof results[0].formatted_address === 'undefined' || results[0].formatted_address === null) {
            $('#address').val(results[1].formatted_address);
            $('.st').val(results[1].formatted_address);
          } else {
            $('#address').val(results[0].formatted_address);
            $('.st').val(results[0].formatted_address);
          }
        } else {
          uk_msg(js_lang.trans_27);
        }
      } else {
        uk_msg(`${js_lang.trans_28} ${status}`);
      }
    });
  }

  $('#get-my-location').click(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(location =>
        successGeo(location, true), setGeoFromIP); // eslint-disable-line no-use-before-define
    } else {
      setGeoFromIP(); // eslint-disable-line no-use-before-define
    }
  });

  function getGeoFromIP(callback) {
    $.ajax({
      type: 'GET',
      url: 'https://geoip-db.com/json/',
      dataType: 'json',
      success: callback,
    });
  }

  function setGeoFromIP() {
    getGeoFromIP((data) => {
      const coords = {
        latitude: data.latitude,
        longitude: data.longitude,
      };

      successGeo({ coords }, true);
    });
  }

//    $('#merchants-sort-options')
})(window, window.google);
